import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    content: {
      list: [],
    },
  },
  getters: {
    list: ({content}) => content.list,
    text: ({content}) => content.text,
  },
  mutations: {
    SET_PRODUCTS(state, value) {
      state.content.list = value;
    },
  },
  actions: {
    async get_products({commit}) {
      try {
        const get_products = await api.database.get_products();
        commit('SET_PRODUCTS', get_products.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
